import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowDownSquare: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"arrow-down-square, bottom"} maskId="square-filled-radius-0-stroke-1-IconArrowDownSquare"><path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V3H21V21ZM11.5 7V15.293L8.5 12.293L7.79297 13L12 17.207L16.207 13L15.5 12.293L12.5 15.293V7H11.5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconArrowDownSquare;
